// extracted by mini-css-extract-plugin
export default {"editorXTemplateDemo":"xeYMz","iframe":"_02BEf","tablet":"fPS-G","mobile":"K7t0O"};